export class FiltrosBlockStudentDto {
  nombre: string;
  campusId: number;
  periodoBlockId: number;
  periodoId: number[];
  programaId: number[];
  ciclocId: number[];
}
